module.exports = __webpack_public_path__ + "static/media/email.21fa396b.svg";